import { useSignal } from '@preact/signals'
import { useEffect } from 'preact/hooks'

interface TimerData {
    startDate: number
    endDate: number
}

type TimeLeft = {
    status: 'not-started' | 'in-progress' | 'finished'
    hours: number
    seconds: number
    minutes: number
}

const MS_SEC = 1000
const MS_MIN = MS_SEC * 60
const MS_HRS = MS_MIN * 60

function getTimeLeft(startDate: number, endDate: number): TimeLeft {
    const started = startDate <= Date.now()
    const diffMS = endDate - Date.now()
    const finished = diffMS <= 0

    return {
        status: !started ? 'not-started' : finished ? 'finished' : 'in-progress',
        seconds: Math.floor(diffMS / MS_SEC) % 60,
        minutes: Math.floor(diffMS / MS_MIN) % 60,
        hours: Math.floor(diffMS / MS_HRS),
    }
}

export function useTimer({ startDate, endDate }: TimerData) {
    const initialTimeLeft = getTimeLeft(startDate, endDate)
    const timeLeftSignal = useSignal<TimeLeft>(initialTimeLeft)

    useEffect(() => {
        if (initialTimeLeft.status !== 'in-progress') return

        const taskID = setInterval(() => {
            timeLeftSignal.value = getTimeLeft(startDate, endDate)

            if (timeLeftSignal.value.status === 'finished') clearInterval(taskID)
        }, 1000)
    }, [])

    return timeLeftSignal.value
}
